import {
    FORGOT_PASSWORD,
    RESET_PASSWORD,
    POST_FORGOT_PASSWORD,
    POST_RESET_PASSWORD,
    postForgotPasswordSuccess,
    postForgotPasswordFailed,
    postResetPasswordSuccess,
    postResetPasswordFailed
} from '../../../actions/app/password/password.actions'
import {API_ERROR, API_SUCCESS, apiRequest} from '../../../actions/core/api/api.actions'
import {setError, setLoader} from '../../../actions/app/ui/ui.actions'
import {setNotification} from '../../../actions/core/notifications/notifications.actions'

export const passwordMiddleware = () => next => action => {
    next(action)

    const {payload} = action

    switch (action.type) {
        case POST_FORGOT_PASSWORD:
            next([
                apiRequest({
                    body: payload.body,
                    method: 'POST',
                    url: payload.data,
                    entity: FORGOT_PASSWORD
                }),
                setLoader({state: true, entity: FORGOT_PASSWORD})
            ])
            break

        case `${FORGOT_PASSWORD} ${API_SUCCESS}`:
            next([
                setNotification({
                    entity: FORGOT_PASSWORD,
                    title: 'Demande envoyée',
                    html: 'Si cet email existe, vous recevrez un lien de réinitialisation.',
                    icon: 'success'
                }),
                setLoader({state: false, entity: FORGOT_PASSWORD}),
                setError({state: false, entity: FORGOT_PASSWORD}),
                postForgotPasswordSuccess(),
            ])
            break

        case `${FORGOT_PASSWORD} ${API_ERROR}`:
            next([
                setNotification({
                    entity: FORGOT_PASSWORD,
                    title: 'Erreur',
                    html: 'Une erreur est survenue. Veuillez réessayer.',
                    icon: 'error'
                }),
                setError({state: true, entity: FORGOT_PASSWORD}),
                setLoader({state: false, entity: FORGOT_PASSWORD}),
                postForgotPasswordFailed(),
            ])
            break

        case POST_RESET_PASSWORD:
            next([
                apiRequest({
                    body: payload.body,
                    method: 'POST',
                    url: payload.data,
                    entity: RESET_PASSWORD
                }),
                setLoader({state: true, entity: RESET_PASSWORD})
            ])
            break

        case `${RESET_PASSWORD} ${API_SUCCESS}`:
            next([
                setNotification({
                    entity: RESET_PASSWORD,
                    title: 'Succès',
                    html: 'Mot de passe réinitialisé avec succès ! Redirection...',
                    icon: 'success',
                    timer: 2000
                }),
                setLoader({state: false, entity: RESET_PASSWORD}),
                setError({state: false, entity: RESET_PASSWORD}),
                postResetPasswordSuccess(),
            ])
            // Redirect to login after 2 seconds
            setTimeout(() => {
                window.location.href = '/login'
            }, 2000)
            break

        case `${RESET_PASSWORD} ${API_ERROR}`:
            const resetErrorMessage = payload.data?.response?.data?.message || 'Une erreur est survenue. Le lien est peut-être expiré.'

            next([
                setNotification({
                    entity: RESET_PASSWORD,
                    title: 'Erreur',
                    html: resetErrorMessage,
                    icon: 'error'
                }),
                setError({state: true, entity: RESET_PASSWORD}),
                setLoader({state: false, entity: RESET_PASSWORD}),
                postResetPasswordFailed(),
            ])
            break

        default:
            break
    }
    return null
}
